export default "__VITE_ASSET__BKAVaxC___"